import { RootState } from "../indexReducers";

export const screenLoaderActive = (state: RootState) =>
  state.loaderReducer.showScreenLoader;
